module.exports = __webpack_public_path__ + "709ec973fa1dcae51983e87675b8119d.png";